import styled from 'styled-components'

const WrapContent = styled.div`
  margin: 8px 16px 24px 16px;
`

const WrapFormItem = styled.div`
  display: flex;
  flex: 1;

  .ant-form-item {
    margin-bottom: 0;
  }
`

const WrapTab = styled.div`
  .ant-tabs-bar {
    margin-bottom: 0;
  }

  .ant-tabs-content {
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-top: 0;
    padding: 16px;
  }

  .ant-list-items,
  .ant-list-header,
  .ant-spin-nested-loading,
  .ant-tabs-tab {
    background: #fff !important;
  }

  .ant-tabs-tab {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  .ant-tabs-tab-active {
    background: #fafafa !important;
    border-bottom: 1px solid #fafafa !important;
  }
`

export { WrapContent, WrapFormItem, WrapTab }
